import React, { useState, useEffect } from 'react';
import api from '../services/api';

function AlcazarPreguntas() {
  const [tab, setTab] = useState('sin_respuesta');
  const [respuestas, setRespuestas] = useState({});
  const [verificando, setVerificando] = useState(null); // key de la pregunta en verificación
  const [guardando, setGuardando] = useState(false);
  const [mensaje, setMensaje] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [contestadasDB, setContestadasDB] = useState([]);
  const [logs, setLogs] = useState([]);
  const [logsStats, setLogsStats] = useState(null);
  const [simulando, setSimulando] = useState(false);
  const [milPreguntas, setMilPreguntas] = useState(null);
  const [categoriaAbierta, setCategoriaAbierta] = useState(null);
  const [respuestaTemp, setRespuestaTemp] = useState({});  // Para escribir respuestas
  const [guardandoPregunta, setGuardandoPregunta] = useState(null);  // Cual se está guardando

  // Preguntas que necesitan respuesta organizadas por topic
  const PREGUNTAS_SIN_RESPUESTA = {
    parking: {
      titulo: 'Parking / Aparcamiento',
      icon: '🅿️',
      color: '#3498db',
      preguntas: [
        { es: '¿Hay parking cerca?', en: 'Is there parking nearby?', de: 'Gibt es einen Parkplatz in der Nähe?', fr: 'Y a-t-il un parking à proximité?', it: "C'è un parcheggio nelle vicinanze?", pt: 'Há estacionamento perto?', ja: '近くに駐車場はありますか？', ko: '근처에 주차장이 있나요?', zh: '附近有停车场吗？', ru: 'Есть парковка рядом?', ar: 'هل يوجد موقف سيارات قريب؟' },
        { es: '¿Dónde puedo aparcar?', en: 'Where can I park?', de: 'Wo kann ich parken?', fr: 'Où puis-je me garer?', it: 'Dove posso parcheggiare?', pt: 'Onde posso estacionar?', ja: 'どこに駐車できますか？', ko: '어디에 주차할 수 있나요?', zh: '哪里可以停车？', ru: 'Где можно припарковаться?', ar: 'أين يمكنني الركن؟' },
        { es: '¿Hay estacionamiento gratuito?', en: 'Is parking free?' },
        { es: '¿Cuánto cuesta el parking?', en: 'How much is parking?' },
        { es: '¿Hay parking para autobuses?', en: 'Is there bus parking?' },
      ]
    },
    ubicacion: {
      titulo: 'Ubicación / Cómo llegar',
      icon: '📍',
      color: '#e74c3c',
      preguntas: [
        { es: '¿Cómo llego al Alcázar?', en: 'How do I get to the Alcazar?', de: 'Wie komme ich zum Alcázar?', fr: "Comment aller à l'Alcazar?", it: "Come arrivo all'Alcázar?", pt: 'Como chego ao Alcázar?', ja: 'アルカサルへの行き方は？', ko: '알카사르까지 어떻게 가나요?', zh: '怎么去阿尔卡萨尔？', ru: 'Как добраться до Алькасара?', ar: 'كيف أصل إلى القصر؟' },
        { es: '¿Cuál es la dirección?', en: 'What is the address?', de: 'Was ist die Adresse?', fr: "Quelle est l'adresse?", it: "Qual è l'indirizzo?", pt: 'Qual é o endereço?', ja: '住所は何ですか？', ko: '주소가 뭐예요?', zh: '地址是什么？', ru: 'Какой адрес?', ar: 'ما هو العنوان؟' },
        { es: '¿Qué metro me deja cerca?', en: 'Which metro station is closest?' },
        { es: '¿Hay parada de autobús cerca?', en: 'Is there a bus stop nearby?' },
        { es: '¿Se puede ir andando desde el centro?', en: 'Can I walk from the city center?' },
      ]
    },
    cancelacion: {
      titulo: 'Cancelaciones / Reembolsos',
      icon: '❌',
      color: '#9b59b6',
      preguntas: [
        { es: 'Quiero cancelar mi reserva', en: 'I want to cancel my booking', de: 'Ich möchte meine Buchung stornieren', fr: 'Je veux annuler ma réservation', it: 'Voglio cancellare la mia prenotazione', pt: 'Quero cancelar a minha reserva', ja: '予約をキャンセルしたいです', ko: '예약을 취소하고 싶어요', zh: '我想取消预订', ru: 'Хочу отменить бронирование', ar: 'أريد إلغاء حجزي' },
        { es: '¿Puedo pedir un reembolso?', en: 'Can I get a refund?', de: 'Kann ich eine Rückerstattung bekommen?', fr: 'Puis-je obtenir un remboursement?', it: 'Posso ottenere un rimborso?', pt: 'Posso pedir reembolso?', ja: '払い戻しはできますか？', ko: '환불받을 수 있나요?', zh: '可以退款吗？', ru: 'Можно получить возврат?', ar: 'هل يمكنني استرداد المبلغ؟' },
        { es: '¿Cómo anulo mi entrada?', en: 'How do I cancel my ticket?' },
        { es: '¿Puedo cambiar la fecha de mi entrada?', en: 'Can I change my ticket date?' },
        { es: '¿Cuál es la política de cancelación?', en: 'What is the cancellation policy?' },
      ]
    },
    accesibilidad: {
      titulo: 'Accesibilidad',
      icon: '♿',
      color: '#27ae60',
      preguntas: [
        { es: '¿Es accesible para sillas de ruedas?', en: 'Is it wheelchair accessible?', de: 'Ist es rollstuhlgerecht?', fr: 'Est-ce accessible en fauteuil roulant?', it: 'È accessibile in sedia a rotelle?', pt: 'É acessível para cadeiras de rodas?', ja: '車椅子でアクセスできますか？', ko: '휠체어 접근이 가능한가요?', zh: '轮椅可以进入吗？', ru: 'Есть доступ для инвалидных колясок?', ar: 'هل يمكن الوصول بالكرسي المتحرك؟' },
        { es: '¿Hay ascensor?', en: 'Is there an elevator?' },
        { es: '¿Tienen sillas de ruedas para prestar?', en: 'Do you have wheelchairs to lend?' },
        { es: '¿Hay baños adaptados?', en: 'Are there accessible restrooms?' },
        { es: '¿Se permite entrar con perro guía?', en: 'Are guide dogs allowed?' },
      ]
    },
    bodas: {
      titulo: 'Bodas / Eventos',
      icon: '💒',
      color: '#e91e63',
      preguntas: [
        { es: 'Quiero hacer un reportaje de boda', en: 'I want a wedding photoshoot', de: 'Ich möchte ein Hochzeitsfotoshooting', fr: 'Je veux un reportage photo de mariage', it: 'Voglio un servizio fotografico per matrimonio', pt: 'Quero um ensaio fotográfico de casamento', ja: '結婚式の写真撮影をしたいです', ko: '웨딩 촬영을 하고 싶어요', zh: '我想拍婚纱照', ru: 'Хочу свадебную фотосессию', ar: 'أريد جلسة تصوير زفاف' },
        { es: '¿Puedo celebrar mi boda allí?', en: 'Can I have my wedding there?' },
        { es: 'Sesión fotográfica profesional para boda', en: 'Professional wedding photography' },
        { es: '¿Se pueden hacer eventos privados?', en: 'Can private events be held?' },
        { es: '¿Qué permisos necesito para fotografía profesional?', en: 'What permits do I need for professional photography?' },
      ]
    },
    comida: {
      titulo: 'Comida / Cafetería',
      icon: '🍽️',
      color: '#f39c12',
      preguntas: [
        { es: '¿Hay cafetería?', en: 'Is there a cafe?', de: 'Gibt es ein Café?', fr: 'Y a-t-il un café?', it: "C'è un bar?", pt: 'Há cafetaria?', ja: 'カフェはありますか？', ko: '카페가 있나요?', zh: '有咖啡厅吗？', ru: 'Есть кафе?', ar: 'هل يوجد مقهى؟' },
        { es: '¿Dónde puedo comer?', en: 'Where can I eat?', de: 'Wo kann ich essen?', fr: 'Où puis-je manger?', it: 'Dove posso mangiare?', pt: 'Onde posso comer?', ja: 'どこで食事できますか？', ko: '어디서 식사할 수 있나요?', zh: '哪里可以吃饭？', ru: 'Где можно поесть?', ar: 'أين يمكنني تناول الطعام؟' },
        { es: '¿Tienen restaurante?', en: 'Is there a restaurant?' },
        { es: '¿Se puede entrar con comida?', en: 'Can I bring food inside?' },
        { es: '¿Hay fuentes de agua?', en: 'Are there water fountains?' },
      ]
    },
    equipaje: {
      titulo: 'Equipaje / Consigna',
      icon: '🧳',
      color: '#795548',
      preguntas: [
        { es: '¿Dónde guardo mi maleta?', en: 'Where can I store my luggage?', de: 'Wo kann ich mein Gepäck aufbewahren?', fr: 'Où puis-je laisser mes bagages?', it: 'Dove posso lasciare il mio bagaglio?', pt: 'Onde posso guardar a minha mala?', ja: '荷物はどこに預けられますか？', ko: '짐은 어디에 보관할 수 있나요?', zh: '行李可以寄存在哪里？', ru: 'Где можно оставить багаж?', ar: 'أين يمكنني تخزين أمتعتي؟' },
        { es: '¿Tienen consigna?', en: 'Do you have luggage storage?' },
        { es: '¿Hay taquillas para mochilas?', en: 'Are there lockers for backpacks?' },
        { es: '¿Puedo entrar con mochila grande?', en: 'Can I enter with a large backpack?' },
        { es: '¿Qué objetos no se pueden entrar?', en: 'What items are not allowed?' },
      ]
    },
    ninos: {
      titulo: 'Niños / Familias',
      icon: '👶',
      color: '#00bcd4',
      preguntas: [
        { es: '¿Hay descuento para niños?', en: 'Is there a discount for children?', de: 'Gibt es Ermäßigung für Kinder?', fr: 'Y a-t-il une réduction pour les enfants?', it: "C'è uno sconto per i bambini?", pt: 'Há desconto para crianças?', ja: '子供割引はありますか？', ko: '어린이 할인이 있나요?', zh: '儿童有折扣吗？', ru: 'Есть скидка для детей?', ar: 'هل يوجد خصم للأطفال؟' },
        { es: '¿Pueden entrar bebés?', en: 'Can babies enter?' },
        { es: '¿Es recomendable para familias?', en: 'Is it recommended for families?' },
        { es: '¿Hay actividades para niños?', en: 'Are there activities for children?' },
        { es: '¿Tienen cambiador de bebés?', en: 'Is there a baby changing room?' },
        { es: '¿Pueden entrar carritos de bebé?', en: 'Are strollers allowed?' },
      ]
    },
    video: {
      titulo: 'Video / Grabación',
      icon: '🎥',
      color: '#673ab7',
      preguntas: [
        { es: '¿Puedo grabar un video?', en: 'Can I record a video?', de: 'Kann ich ein Video aufnehmen?', fr: 'Puis-je filmer?', it: 'Posso registrare un video?', pt: 'Posso gravar um vídeo?', ja: '動画を撮影できますか？', ko: '동영상 촬영할 수 있나요?', zh: '可以录像吗？', ru: 'Можно снимать видео?', ar: 'هل يمكنني التصوير بالفيديو؟' },
        { es: '¿Se permite filmar?', en: 'Is filming allowed?' },
        { es: '¿Se permite usar trípode?', en: 'Are tripods allowed?' },
        { es: '¿Necesito permiso para grabar?', en: 'Do I need permission to film?' },
      ]
    },
    horario: {
      titulo: 'Horarios (Mejorar)',
      icon: '🕐',
      color: '#607d8b',
      preguntas: [
        { es: '¿A qué hora abren?', en: 'What time do you open?', de: 'Wann öffnen Sie?', fr: 'À quelle heure ouvrez-vous?', it: 'A che ora aprite?', pt: 'A que horas abrem?', ja: '何時に開きますか？', ko: '몇 시에 문을 여나요?', zh: '几点开门？', ru: 'Во сколько открываетесь?', ar: 'متى تفتحون؟' },
        { es: '¿A qué hora cierran?', en: 'What time do you close?', de: 'Wann schließen Sie?', fr: 'À quelle heure fermez-vous?', it: 'A che ora chiudete?', pt: 'A que horas fecham?', ja: '何時に閉まりますか？', ko: '몇 시에 문을 닫나요?', zh: '几点关门？', ru: 'Во сколько закрываетесь?', ar: 'متى تغلقون؟' },
        { es: '¿Abren los domingos?', en: 'Are you open on Sundays?', de: 'Haben Sie sonntags geöffnet?', fr: 'Êtes-vous ouvert le dimanche?', it: 'Siete aperti la domenica?', pt: 'Estão abertos ao domingo?', ja: '日曜日は開いていますか？', ko: '일요일에 열어요?', zh: '周日开放吗？', ru: 'Работаете по воскресеньям?', ar: 'هل تفتحون يوم الأحد؟' },
        { es: '¿Abren los festivos?', en: 'Are you open on holidays?' },
        { es: '¿Cuál es el horario en Navidad?', en: 'What are the Christmas hours?' },
        { es: '¿Cuál es el horario en verano?', en: 'What are the summer hours?' },
        { es: '¿Cuál es la última hora de entrada?', en: 'What is the last entry time?' },
      ]
    },
    precio: {
      titulo: 'Precios (Mejorar)',
      icon: '💶',
      color: '#4caf50',
      preguntas: [
        { es: '¿Hay descuento para estudiantes?', en: 'Is there a student discount?', de: 'Gibt es Studentenrabatt?', fr: 'Y a-t-il une réduction pour étudiants?', it: "C'è uno sconto per studenti?", pt: 'Há desconto para estudantes?', ja: '学生割引はありますか？', ko: '학생 할인이 있나요?', zh: '有学生折扣吗？', ru: 'Есть скидка для студентов?', ar: 'هل يوجد خصم للطلاب؟' },
        { es: '¿Los niños pagan entrada?', en: 'Do children pay for entry?', de: 'Zahlen Kinder Eintritt?', fr: 'Les enfants paient-ils?', it: 'I bambini pagano?', pt: 'As crianças pagam?', ja: '子供は料金がかかりますか？', ko: '어린이도 요금을 내나요?', zh: '儿童需要买票吗？', ru: 'Дети платят?', ar: 'هل الأطفال يدفعون؟' },
        { es: '¿Hay entrada gratuita algún día?', en: 'Is there free entry any day?' },
        { es: '¿Cuánto cuesta para jubilados?', en: 'How much for seniors?' },
        { es: '¿Hay descuento para residentes de Sevilla?', en: 'Is there a discount for Seville residents?' },
        { es: '¿Hay entrada familiar?', en: 'Is there a family ticket?' },
      ]
    },
  };

  useEffect(() => {
    // Cargar respuestas guardadas, contestadas y las 1000 preguntas
    Promise.all([
      api.get('/api/alcazar/respuestas').then(r => r.data).catch(() => ({ respuestas: {} })),
      api.get('/api/alcazar/contestadas').then(r => r.data).catch(() => ({ contestadas: [] })),
      api.get('/api/alcazar/logs', { params: { limite: 100 } }).then(r => r.data).catch(() => ({ logs: [], stats: null })),
      api.get('/api/alcazar/1000-preguntas').then(r => r.data).catch(() => ({ data: [] }))
    ]).then(([respData, contData, logsData, milData]) => {
      if (respData.respuestas) setRespuestas(respData.respuestas);
      if (contData.contestadas) setContestadasDB(contData.contestadas);
      if (logsData.logs) setLogs(logsData.logs);
      if (logsData.stats) setLogsStats(logsData.stats);
      if (milData.data) setMilPreguntas(milData);
      setCargando(false);
    });
  }, []);

  // Función para simular emails
  const ejecutarSimulacion = async (cantidad = 100) => {
    setSimulando(true);
    try {
      const response = await api.get('/api/alcazar/simular', { params: { cantidad } });
      const data = response.data;
      if (data.success) {
        setMensaje({ tipo: 'success', texto: `Simulación completada: ${data.simulacion.porcentajeExito}% de éxito` });
        // Recargar logs
        const logsResp = await api.get('/api/alcazar/logs', { params: { limite: 100 } });
        const logsData = logsResp.data;
        if (logsData.logs) setLogs(logsData.logs);
        if (logsData.stats) setLogsStats(logsData.stats);
      }
    } catch (error) {
      setMensaje({ tipo: 'error', texto: 'Error en simulación' });
    }
    setSimulando(false);
    setTimeout(() => setMensaje(null), 5000);
  };

  const handleChange = (topic, index, value) => {
    const key = `${topic}_${index}`;
    setRespuestas(prev => ({ ...prev, [key]: value }));
  };

  // Paso 1: Verificar respuesta
  const verificarRespuesta = (topic, index) => {
    const key = `${topic}_${index}`;
    const respuesta = respuestas[key];

    if (!respuesta || respuesta.trim() === '') {
      setMensaje({ tipo: 'error', texto: '⚠️ Escribe una respuesta primero' });
      setTimeout(() => setMensaje(null), 3000);
      return;
    }

    if (respuesta.trim().length < 20) {
      setMensaje({ tipo: 'error', texto: '⚠️ La respuesta es muy corta (mínimo 20 caracteres)' });
      setTimeout(() => setMensaje(null), 3000);
      return;
    }

    setVerificando(key);
  };

  // Paso 2: Confirmar y guardar (XIA memoriza)
  const confirmarYGuardar = async (topic, index, preguntaEs) => {
    const key = `${topic}_${index}`;
    const respuesta = respuestas[key];

    setGuardando(true);
    try {
      const response = await api.post('/api/alcazar/memorizar', {
        topic,
        questionIndex: index,
        respuestaEs: respuesta.trim(),
        preguntaOriginal: preguntaEs
      });

      const data = response.data;

      if (data.success) {
        setMensaje({
          tipo: 'success',
          texto: `✅ ¡XIA ha memorizado! Traducido a ${data.idiomas || 12} idiomas`
        });
        // Marcar como guardado
        setRespuestas(prev => ({
          ...prev,
          [key]: respuesta.trim(),
          [`${key}_saved`]: true
        }));
        setVerificando(null);

        // Recargar contestadas
        api.get('/api/alcazar/contestadas')
          .then(r => {
            if (r.data.contestadas) setContestadasDB(r.data.contestadas);
          });
      } else {
        setMensaje({ tipo: 'error', texto: '❌ Error: ' + (data.error || 'Error desconocido') });
      }
    } catch (error) {
      setMensaje({ tipo: 'error', texto: '❌ Error de conexión al servidor' });
    }

    setGuardando(false);
    setTimeout(() => setMensaje(null), 5000);
  };

  // Cancelar verificación
  const cancelarVerificacion = () => {
    setVerificando(null);
  };

  // Guardar respuesta desde las 1000 preguntas
  const guardarRespuesta1000 = async (tema, preguntaIdx, preguntaTexto) => {
    const key = `${tema}:${preguntaIdx}`;
    const respuesta = respuestaTemp[key];

    if (!respuesta || respuesta.trim().length < 10) {
      setMensaje({ tipo: 'error', texto: '⚠️ La respuesta debe tener al menos 10 caracteres' });
      setTimeout(() => setMensaje(null), 3000);
      return;
    }

    setGuardandoPregunta(key);

    try {
      const response = await api.post('/api/alcazar/memorizar', {
        topic: tema,
        questionIndex: preguntaIdx,
        respuestaEs: respuesta.trim(),
        preguntaOriginal: preguntaTexto
      });

      const data = response.data;

      if (data.success) {
        setMensaje({
          tipo: 'success',
          texto: `✅ ¡Guardado! Traducido a 12 idiomas`
        });

        // Limpiar el campo
        setRespuestaTemp(prev => ({ ...prev, [key]: '' }));

        // Recargar contestadas
        const contResp = await api.get('/api/alcazar/contestadas');
        if (contResp.data.contestadas) setContestadasDB(contResp.data.contestadas);
      } else {
        setMensaje({ tipo: 'error', texto: '❌ Error: ' + (data.error || 'Error desconocido') });
      }
    } catch (error) {
      setMensaje({ tipo: 'error', texto: '❌ Error de conexión' });
    }

    setGuardandoPregunta(null);
    setTimeout(() => setMensaje(null), 4000);
  };

  if (cargando) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Cargando base de conocimiento...</p>
        </div>
      </div>
    );
  }

  const totalSinRespuesta = Object.values(PREGUNTAS_SIN_RESPUESTA).reduce((acc, t) => acc + t.preguntas.length, 0);
  const totalRespondidas = Object.keys(respuestas).filter(k => respuestas[`${k}_saved`]).length;

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <div className="bg-gradient-to-r from-amber-700 to-amber-900 text-white py-6 px-4 shadow-lg">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-3xl font-bold flex items-center gap-3">
            🏰 Real Alcázar de Sevilla
          </h1>
          <p className="mt-2 opacity-90 text-lg">XIA 3.0 - Base de Conocimiento</p>
          <p className="text-sm opacity-75 mt-1">
            Enseña a XIA las respuestas que no sabe. Se traducirán automáticamente a 12 idiomas.
          </p>
        </div>
      </div>

      {/* Mensaje flotante */}
      {mensaje && (
        <div className={`fixed top-4 right-4 px-6 py-4 rounded-lg shadow-lg z-50 max-w-md ${
          mensaje.tipo === 'success' ? 'bg-green-500' :
          mensaje.tipo === 'error' ? 'bg-red-500' : 'bg-yellow-500'
        } text-white font-medium`}>
          {mensaje.texto}
        </div>
      )}

      {/* Modal de verificación */}
      {verificando && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-auto">
            <div className="bg-amber-600 text-white px-6 py-4 rounded-t-xl">
              <h3 className="text-xl font-bold">🔍 Verificar respuesta</h3>
              <p className="text-sm opacity-90">Revisa que la respuesta sea correcta antes de que XIA la memorice</p>
            </div>

            <div className="p-6">
              {(() => {
                const [topic, index] = verificando.split('_');
                const pregunta = PREGUNTAS_SIN_RESPUESTA[topic]?.preguntas[parseInt(index)];
                const respuesta = respuestas[verificando];

                return (
                  <>
                    <div className="mb-4">
                      <div className="text-sm text-gray-500 mb-1">Pregunta:</div>
                      <div className="font-semibold text-lg text-gray-800">
                        🇪🇸 {pregunta?.es}
                      </div>
                      {pregunta?.en && (
                        <div className="text-gray-500 text-sm mt-1">
                          🇬🇧 {pregunta.en}
                        </div>
                      )}
                    </div>

                    <div className="mb-6">
                      <div className="text-sm text-gray-500 mb-1">Tu respuesta:</div>
                      <div className="bg-amber-50 border-2 border-amber-200 rounded-lg p-4 text-gray-800">
                        {respuesta}
                      </div>
                    </div>

                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
                      <div className="text-blue-800 font-medium mb-2">
                        📋 Al confirmar, XIA:
                      </div>
                      <ul className="text-blue-700 text-sm space-y-1">
                        <li>✓ Memorizará esta respuesta</li>
                        <li>✓ La traducirá a 12 idiomas automáticamente</li>
                        <li>✓ Podrá contestar esta pregunta en cualquier idioma</li>
                      </ul>
                    </div>

                    <div className="flex gap-3">
                      <button
                        onClick={cancelarVerificacion}
                        className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-800 py-3 px-6 rounded-lg font-medium"
                      >
                        ← Volver a editar
                      </button>
                      <button
                        onClick={() => confirmarYGuardar(topic, parseInt(index), pregunta?.es)}
                        disabled={guardando}
                        className="flex-1 bg-green-600 hover:bg-green-700 text-white py-3 px-6 rounded-lg font-medium disabled:opacity-50"
                      >
                        {guardando ? '⏳ Guardando...' : '✅ Confirmar y que XIA memorice'}
                      </button>
                    </div>
                  </>
                );
              })()}
            </div>
          </div>
        </div>
      )}

      {/* Tabs */}
      <div className="sticky top-0 bg-white shadow-md z-40">
        <div className="max-w-5xl mx-auto">
          <div className="flex">
            <button
              onClick={() => setTab('contestadas')}
              className={`flex-1 py-4 px-6 font-semibold text-lg transition-colors ${
                tab === 'contestadas'
                  ? 'bg-green-500 text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              ✅ XIA Sabe ({contestadasDB.length})
            </button>
            <button
              onClick={() => setTab('sin_respuesta')}
              className={`flex-1 py-4 px-6 font-semibold text-lg transition-colors ${
                tab === 'sin_respuesta'
                  ? 'bg-red-500 text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              ❌ XIA No Sabe ({totalSinRespuesta})
            </button>
            <button
              onClick={() => setTab('logs')}
              className={`flex-1 py-4 px-6 font-semibold text-lg transition-colors ${
                tab === 'logs'
                  ? 'bg-blue-500 text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              📊 Logs
            </button>
            <button
              onClick={() => setTab('1000')}
              className={`flex-1 py-4 px-6 font-semibold text-lg transition-colors ${
                tab === '1000'
                  ? 'bg-purple-500 text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              📚 1000 Preguntas
            </button>
          </div>
        </div>
      </div>

      {/* Contenido */}
      <div className="max-w-5xl mx-auto py-6 px-4">

        {/* Tab Contestadas */}
        {tab === 'contestadas' && (
          <div>
            <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
              <h2 className="text-green-800 font-semibold text-lg">
                ✅ Preguntas que XIA sabe contestar ({contestadasDB.length} respuestas)
              </h2>
              <p className="text-green-700 mt-1">
                Cada respuesta está traducida a 12 idiomas. Haz clic en una tarjeta para ver todos los idiomas.
              </p>
            </div>

            {contestadasDB.length === 0 ? (
              <div className="text-center py-12 text-gray-500">
                <div className="text-6xl mb-4">📭</div>
                <p>Aún no hay respuestas en la base de datos.</p>
                <p className="text-sm mt-2">Ve a la pestaña "XIA No Sabe" para añadir respuestas.</p>
              </div>
            ) : (
              <div className="space-y-4">
                {contestadasDB.map((item, index) => {
                  const topicName = item.topic?.split(':')[0] || item.topic;
                  const questionIdx = item.topic?.split(':')[1] || '0';
                  const topicConfig = PREGUNTAS_SIN_RESPUESTA[topicName];
                  const preguntaOriginal = topicConfig?.preguntas?.[parseInt(questionIdx)];
                  const respuestaEs = item.respuestas?.es?.content || item.content;
                  const idiomas = item.respuestas ? Object.keys(item.respuestas) : [];

                  return (
                    <div key={index} className="bg-white rounded-xl shadow-md overflow-hidden">
                      {/* Header con tema */}
                      <div
                        className="px-4 py-3 text-white font-medium flex items-center gap-2 cursor-pointer"
                        style={{ backgroundColor: topicConfig?.color || '#4CAF50' }}
                        onClick={() => {
                          const el = document.getElementById(`expandido-${index}`);
                          if (el) el.classList.toggle('hidden');
                        }}
                      >
                        <span className="text-xl">{topicConfig?.icon || '📋'}</span>
                        <span className="flex-1">{topicConfig?.titulo || topicName}</span>
                        <span className="text-sm opacity-75 bg-white/20 px-2 py-1 rounded">
                          {idiomas.length} idiomas
                        </span>
                        <span className="text-lg">▼</span>
                      </div>

                      {/* Contenido */}
                      <div className="p-4">
                        {/* Pregunta original */}
                        <div className="mb-3">
                          <div className="text-xs text-gray-500 uppercase mb-1">Pregunta:</div>
                          <div className="font-semibold text-gray-800 text-lg flex items-center gap-2">
                            <span>🇪🇸</span>
                            <span>{preguntaOriginal?.es || `Pregunta #${questionIdx}`}</span>
                          </div>
                          {preguntaOriginal?.en && (
                            <div className="text-gray-500 text-sm mt-1 flex items-center gap-2">
                              <span>🇬🇧</span>
                              <span>{preguntaOriginal.en}</span>
                            </div>
                          )}
                        </div>

                        {/* Respuesta en español */}
                        <div className="mb-3">
                          <div className="text-xs text-gray-500 uppercase mb-1">Respuesta (Español):</div>
                          <div className="bg-green-50 border-l-4 border-green-500 p-4 rounded text-gray-800">
                            {respuestaEs}
                          </div>
                        </div>

                        {/* Traducciones expandibles */}
                        <div id={`expandido-${index}`} className="hidden mt-4 border-t pt-4">
                          <div className="text-xs text-gray-500 uppercase mb-2">Traducciones disponibles:</div>
                          <div className="grid gap-2">
                            {idiomas.filter(l => l !== 'es').map(lang => {
                              const flags = {
                                en: '🇬🇧', fr: '🇫🇷', de: '🇩🇪', it: '🇮🇹', pt: '🇵🇹',
                                ja: '🇯🇵', ko: '🇰🇷', zh: '🇨🇳', ru: '🇷🇺', ar: '🇸🇦', nl: '🇳🇱'
                              };
                              const nombres = {
                                en: 'English', fr: 'Français', de: 'Deutsch', it: 'Italiano', pt: 'Português',
                                ja: '日本語', ko: '한국어', zh: '中文', ru: 'Русский', ar: 'العربية', nl: 'Nederlands'
                              };
                              return (
                                <div key={lang} className="bg-gray-50 rounded-lg p-3">
                                  <div className="flex items-center gap-2 mb-1">
                                    <span>{flags[lang] || '🌐'}</span>
                                    <span className="font-medium text-sm text-gray-700">{nombres[lang] || lang.toUpperCase()}</span>
                                  </div>
                                  <div className="text-gray-600 text-sm">
                                    {item.respuestas?.[lang]?.content || 'Sin traducción'}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>

                        {/* Botón para expandir */}
                        <button
                          onClick={() => {
                            const el = document.getElementById(`expandido-${index}`);
                            if (el) el.classList.toggle('hidden');
                          }}
                          className="mt-2 text-sm text-blue-600 hover:text-blue-800 flex items-center gap-1"
                        >
                          📖 Ver traducciones en {idiomas.length - 1} idiomas más
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {/* Tab Sin Respuesta */}
        {tab === 'sin_respuesta' && (
          <div>
            <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
              <h2 className="text-red-800 font-semibold text-lg">
                ❌ Preguntas que XIA NO sabe contestar
              </h2>
              <p className="text-red-700 mt-1">
                <strong>Paso 1:</strong> Escribe la respuesta en español<br/>
                <strong>Paso 2:</strong> Pulsa "Verificar" para revisar<br/>
                <strong>Paso 3:</strong> Confirma y XIA memorizará (traducción automática a 12 idiomas)
              </p>
            </div>

            {Object.entries(PREGUNTAS_SIN_RESPUESTA).map(([topic, data]) => (
              <div key={topic} className="mb-8 bg-white rounded-xl shadow-md overflow-hidden">
                <div
                  className="px-6 py-4 text-white font-bold text-xl flex items-center gap-3"
                  style={{ backgroundColor: data.color }}
                >
                  <span>{data.icon}</span>
                  <span>{data.titulo}</span>
                </div>

                <div className="p-6 space-y-6">
                  {data.preguntas.map((pregunta, index) => {
                    const key = `${topic}_${index}`;
                    const guardada = respuestas[`${key}_saved`];
                    const tieneTexto = respuestas[key] && respuestas[key].trim() !== '';

                    return (
                      <div key={index} className={`border-b border-gray-100 pb-6 last:border-0 last:pb-0 ${guardada ? 'opacity-50' : ''}`}>
                        {/* Pregunta principal */}
                        <div className="font-semibold text-gray-800 text-lg mb-2 flex items-start gap-2">
                          <span>🇪🇸</span>
                          <span>{pregunta.es}</span>
                          {guardada && <span className="text-green-600 text-sm">✅ Memorizada</span>}
                        </div>

                        {/* Traducciones */}
                        <div className="text-sm text-gray-500 mb-3 grid grid-cols-2 gap-1">
                          {pregunta.en && <div>🇬🇧 {pregunta.en}</div>}
                          {pregunta.fr && <div>🇫🇷 {pregunta.fr}</div>}
                          {pregunta.de && <div>🇩🇪 {pregunta.de}</div>}
                          {pregunta.it && <div>🇮🇹 {pregunta.it}</div>}
                          {pregunta.pt && <div>🇵🇹 {pregunta.pt}</div>}
                          {pregunta.ja && <div>🇯🇵 {pregunta.ja}</div>}
                          {pregunta.ko && <div>🇰🇷 {pregunta.ko}</div>}
                          {pregunta.zh && <div>🇨🇳 {pregunta.zh}</div>}
                          {pregunta.ru && <div>🇷🇺 {pregunta.ru}</div>}
                          {pregunta.ar && <div>🇸🇦 {pregunta.ar}</div>}
                        </div>

                        {!guardada && (
                          <>
                            {/* Campo de respuesta */}
                            <div className="mb-3">
                              <textarea
                                value={respuestas[key] || ''}
                                onChange={(e) => handleChange(topic, index, e.target.value)}
                                placeholder="Escribe aquí la respuesta en español..."
                                className="w-full border border-gray-300 rounded-lg p-3 min-h-[80px] focus:ring-2 focus:ring-amber-500 focus:border-amber-500"
                              />
                            </div>

                            {/* Botón verificar */}
                            <button
                              onClick={() => verificarRespuesta(topic, index)}
                              disabled={!tieneTexto}
                              className={`w-full py-3 rounded-lg font-medium transition-colors ${
                                tieneTexto
                                  ? 'bg-amber-600 hover:bg-amber-700 text-white'
                                  : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                              }`}
                            >
                              🔍 Verificar respuesta
                            </button>
                          </>
                        )}

                        {guardada && (
                          <div className="bg-green-50 border border-green-200 rounded-lg p-3 text-green-700">
                            ✅ XIA ya sabe contestar esta pregunta en 12 idiomas
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Tab Logs */}
        {tab === 'logs' && (
          <div>


            {/* Botones de simulación */}
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-6">
              <h3 className="font-semibold text-gray-800 mb-3">Simulación de emails</h3>
              <div className="flex gap-3 flex-wrap">
                <button
                  onClick={() => ejecutarSimulacion(100)}
                  disabled={simulando}
                  className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 disabled:opacity-50"
                >
                  {simulando ? '⏳ Simulando...' : '🧪 Simular 100'}
                </button>
                <button
                  onClick={() => ejecutarSimulacion(500)}
                  disabled={simulando}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
                >
                  🧪 Simular 500
                </button>
                <button
                  onClick={() => ejecutarSimulacion(1000)}
                  disabled={simulando}
                  className="px-4 py-2 bg-blue-700 text-white rounded-lg hover:bg-blue-800 disabled:opacity-50"
                >
                  🧪 Simular 1000
                </button>
              </div>
            </div>

            {/* Lista de logs */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden">
              <div className="bg-blue-600 px-4 py-3 text-white font-semibold flex items-center justify-between">
                <span>Ultimos eventos procesados</span>
                <div className="flex gap-1">
                  {['all','email','whatsapp'].map(ch => (
                    <button key={ch} onClick={() => {/* TODO: filter */}}
                      className="px-2 py-0.5 rounded text-xs bg-blue-500 hover:bg-blue-400">
                      {ch === 'all' ? 'Todos' : ch === 'email' ? 'Email' : 'WhatsApp'}
                    </button>
                  ))}
                </div>
              </div>
              <div className="divide-y divide-gray-100">
                {logs.length === 0 ? (
                  <div className="p-8 text-center text-gray-500">
                    No hay logs disponibles. Ejecuta una simulación.
                  </div>
                ) : (
                  logs.map((log, index) => (
                    <div key={index} className="p-4 hover:bg-gray-50">
                      <div className="flex items-start gap-3">
                        <span className={`text-2xl ${log.response_found ? '✅' : '❌'}`}>
                          {log.response_found ? '✅' : '❌'}
                        </span>
                        <div className="flex-1 min-w-0">
                          <div className="font-medium text-gray-800 truncate flex items-center gap-2">
                            {log.channel === 'whatsapp' ? (
                              <span className="inline-block px-1.5 py-0.5 bg-green-100 text-green-700 rounded text-xs flex-shrink-0">WA</span>
                            ) : log.channel === 'chat' ? (
                              <span className="inline-block px-1.5 py-0.5 bg-orange-100 text-orange-700 rounded text-xs flex-shrink-0">Chat</span>
                            ) : (
                              <span className="inline-block px-1.5 py-0.5 bg-blue-100 text-blue-700 rounded text-xs flex-shrink-0">Email</span>
                            )}
                            {log.subject || log.email_subject}
                          </div>
                          <div className="text-sm text-gray-500 mt-1">
                            {log.sender && (
                              <span className="inline-block bg-gray-50 px-2 py-0.5 rounded mr-2 text-xs text-gray-400">
                                {log.channel === 'whatsapp' ? ('...' + (log.sender || '').slice(-4)) : log.sender}
                              </span>
                            )}
                            <span className="inline-block bg-gray-100 px-2 py-0.5 rounded mr-2">
                              {log.detected_language?.toUpperCase()}
                            </span>
                            <span className="inline-block bg-gray-100 px-2 py-0.5 rounded mr-2">
                              {log.detected_topic}
                            </span>
                            <span className={`inline-block px-2 py-0.5 rounded ${
                              log.action === 'RESPONDIDO' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
                            }`}>
                              {log.action}
                            </span>
                            {log.forwarded_to && (
                              <span className="ml-2 text-xs text-gray-400">
                                → {log.forwarded_to}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="text-xs text-gray-400">
                          {log.processing_time_ms}ms
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        )}

        {/* Tab 1000 Preguntas */}
        {tab === '1000' && milPreguntas && (
          <div>
            <div className="bg-purple-50 border border-purple-200 rounded-lg p-4 mb-6">
              <h2 className="text-purple-800 font-semibold text-lg">
                📚 Base de 1000+ Preguntas del Alcázar
              </h2>
              <p className="text-purple-700 mt-1">
                {milPreguntas.totalPreguntas} preguntas en {milPreguntas.categorias} categorías.
                Las preguntas con ✅ tienen respuesta de XIA.
              </p>
            </div>

            {/* Resumen de categorías */}
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 mb-6">
              {milPreguntas.data?.map((cat, idx) => {
                const colores = ['#4CAF50', '#2196F3', '#9C27B0', '#FF9800', '#E91E63', '#00BCD4', '#795548', '#607D8B', '#3F51B5', '#F44336', '#8BC34A', '#FF5722', '#673AB7', '#009688', '#FFEB3B', '#CDDC39', '#FF4081', '#536DFE', '#00E676', '#FF6E40', '#7C4DFF'];
                const icons = ['🕐', '💶', '📍', '♿', '🎤', '🏛️', '🌳', '📷', '👥', '💒', '🐕', '🧳', '☕', '🛍️', '❌', '👑', '👶', '🚻', '🆚', '⭐', '❓'];
                return (
                  <button
                    key={idx}
                    onClick={() => setCategoriaAbierta(categoriaAbierta === cat.tema ? null : cat.tema)}
                    className={`p-3 rounded-lg text-left transition-all ${
                      categoriaAbierta === cat.tema
                        ? 'ring-2 ring-purple-500 shadow-lg'
                        : 'hover:shadow-md'
                    }`}
                    style={{ backgroundColor: colores[idx % colores.length] + '20', borderLeft: `4px solid ${colores[idx % colores.length]}` }}
                  >
                    <div className="flex items-center gap-2">
                      <span className="text-xl">{icons[idx % icons.length]}</span>
                      <div>
                        <div className="font-medium text-gray-800 text-sm">{cat.nombre}</div>
                        <div className="text-xs text-gray-600">{cat.preguntas.length} preguntas</div>
                      </div>
                    </div>
                  </button>
                );
              })}
            </div>

            {/* Lista de preguntas por categoría */}
            {milPreguntas.data?.map((cat, catIdx) => {
              const colores = ['#4CAF50', '#2196F3', '#9C27B0', '#FF9800', '#E91E63', '#00BCD4', '#795548', '#607D8B', '#3F51B5', '#F44336', '#8BC34A', '#FF5722', '#673AB7', '#009688', '#FFEB3B', '#CDDC39', '#FF4081', '#536DFE', '#00E676', '#FF6E40', '#7C4DFF'];
              const icons = ['🕐', '💶', '📍', '♿', '🎤', '🏛️', '🌳', '📷', '👥', '💒', '🐕', '🧳', '☕', '🛍️', '❌', '👑', '👶', '🚻', '🆚', '⭐', '❓'];
              const isOpen = categoriaAbierta === cat.tema || categoriaAbierta === null;

              if (!isOpen && categoriaAbierta !== null) return null;

              return (
                <div key={catIdx} className="mb-6 bg-white rounded-xl shadow-md overflow-hidden">
                  <div
                    className="px-6 py-4 text-white font-bold text-lg flex items-center gap-3 cursor-pointer"
                    style={{ backgroundColor: colores[catIdx % colores.length] }}
                    onClick={() => setCategoriaAbierta(categoriaAbierta === cat.tema ? null : cat.tema)}
                  >
                    <span className="text-2xl">{icons[catIdx % icons.length]}</span>
                    <span className="flex-1">{cat.nombre}</span>
                    <span className="bg-white/30 px-3 py-1 rounded-full text-sm">
                      {cat.preguntas.length} preguntas
                    </span>
                  </div>

                  <div className="divide-y divide-gray-100">
                    {cat.preguntas.map((pregunta, pregIdx) => {
                      // Buscar si hay respuesta para esta pregunta
                      const topicKey = `${cat.tema}:${pregIdx}`;
                      const respuestaDB = contestadasDB.find(c =>
                        c.topic === cat.tema && c.questionIndex === pregIdx
                      );
                      const tieneRespuesta = !!respuestaDB;
                      const respuestaEs = respuestaDB?.respuestas?.es?.content;

                      const inputKey = `${cat.tema}:${pregIdx}`;
                      const isGuardando = guardandoPregunta === inputKey;

                      return (
                        <div key={pregIdx} className={`p-4 ${tieneRespuesta ? 'bg-green-50' : 'hover:bg-gray-50'}`}>
                          <div className="flex items-start gap-3">
                            <span className={`text-lg ${tieneRespuesta ? 'text-green-600' : 'text-gray-400'}`}>
                              {tieneRespuesta ? '✅' : '❌'}
                            </span>
                            <div className="flex-1">
                              <div className="font-medium text-gray-800">
                                {pregIdx + 1}. {pregunta}
                              </div>

                              {/* Si tiene respuesta, mostrarla */}
                              {tieneRespuesta && respuestaEs && (
                                <div className="mt-2 bg-green-100 border-l-4 border-green-500 p-3 rounded text-sm text-gray-700">
                                  <div className="text-xs text-green-600 font-semibold mb-1">💬 Respuesta de XIA:</div>
                                  {respuestaEs}
                                </div>
                              )}

                              {/* Si NO tiene respuesta, mostrar campo para escribir */}
                              {!tieneRespuesta && (
                                <div className="mt-3 space-y-2">
                                  <textarea
                                    value={respuestaTemp[inputKey] || ''}
                                    onChange={(e) => setRespuestaTemp(prev => ({ ...prev, [inputKey]: e.target.value }))}
                                    placeholder="Escribe la respuesta en español... (se traducirá a 12 idiomas)"
                                    className="w-full border border-gray-300 rounded-lg p-3 text-sm min-h-[80px] focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                                    disabled={isGuardando}
                                  />
                                  <button
                                    onClick={() => guardarRespuesta1000(cat.tema, pregIdx, pregunta)}
                                    disabled={isGuardando || !respuestaTemp[inputKey]?.trim()}
                                    className={`w-full py-2 rounded-lg font-medium text-sm transition-colors ${
                                      respuestaTemp[inputKey]?.trim()
                                        ? 'bg-purple-600 hover:bg-purple-700 text-white'
                                        : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                    }`}
                                  >
                                    {isGuardando ? '⏳ Guardando y traduciendo...' : '💾 Guardar respuesta'}
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Footer */}
        <div className="text-center py-8 text-gray-500">
          <p>XIA 3.0 - Sistema de Automatización de Emails</p>
          <p className="text-sm">Infoticketing - 2026</p>
        </div>
      </div>
    </div>
  );
}

export default AlcazarPreguntas;
